import { render, staticRenderFns } from "./CreateDriver.vue?vue&type=template&id=6d378799&lang=pug&"
import script from "./CreateDriver.vue?vue&type=script&lang=ts&"
export * from "./CreateDriver.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDriver.vue?vue&type=style&index=0&id=6d378799&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports